import { Fragment } from 'react'

import { FilesPreviewGallery } from '../../../FilesPreviewGallery'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../Table'
import { useDocFlowMappingResultPdf } from '../../DocFlow.hooks'
import { DOC_FLOW_MAPPING_RESULT_TABLE_ACTION_MAP_RECIPIENT } from '../DocFlowMappingResultTable'

import { renderCell } from './DocFlowMappingResultTableRow.utils'

import * as styles from './DocFlowMappingResultTableRow.module.css'

function DocFlowMappingResultTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  hideCheckbox,
  isLoading,
  isResizing,
  isSelected,
  item,
  phaseDisabled,
  resizingColumn,
  scrollRef,
  showCellBorder,
  onCallAction,
  ...restProps
}) {
  const {
    handleCallAction,
    handleClick,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, onCallAction, ...restProps })

  const {
    activeFile,
    activeFileIndex,
    handleClickResultFile,
    handleCloseFilePreview,
    preparedFile,
  } = useDocFlowMappingResultPdf({ item })

  function handleClickMapRecipient() {
    onCallAction(DOC_FLOW_MAPPING_RESULT_TABLE_ACTION_MAP_RECIPIENT, item)
  }

  const className = useTableRowModClassName({
    className: styles.DocFlowMappingResultTableRow,
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  return (
    <div
      {...qaProps}
      className={className}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={phaseDisabled || hideCheckbox}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            activeFile,
            isActive: column.name === resizingColumn,
            isLoading,
            isResizing,
            item,
            name: column.name,
            scrollRef,
            showCellBorder,
            width: column.width,
            onClickFile: phaseDisabled
              ? handleClickResultFile
              : handleClickMapRecipient,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item).length > 0 && !phaseDisabled ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
      {activeFileIndex === null ? null : (
        <FilesPreviewGallery
          files={[preparedFile]}
          initActive={activeFileIndex}
          onClose={handleCloseFilePreview}
        />
      )}
    </div>
  )
}

export default DocFlowMappingResultTableRow
